import { IPaymentPlanServiceMock } from './payment-plan.mock.types';

export const mockPaymentPlanService = (): IPaymentPlanServiceMock => ({
  fetchPaymentPlans: jest.fn(),
  fetchPaymentPlan: jest.fn(),
  createPaymentPlan: jest.fn(),
  updatePaymentPlan: jest.fn(),
  deletePaymentPlan: jest.fn(),
  cancelPaymentPlan: jest.fn(),
  //Schedule
  fetchPaymentPlanSchedules: jest.fn(),
  fetchPaymentPlanSchedule: jest.fn(),
  createPaymentPlanSchedule: jest.fn(),
  updatePaymentPlanSchedule: jest.fn(),
  deletePaymentPlanSchedule: jest.fn(),
  createPaymentPlanScheduleInvoice: jest.fn()
});
